import React from "react";

export function MultiSelect(props:{mode:string, checked:boolean, disabled: boolean}) {
    const {mode, checked, disabled} = props;
    return (
        <div className="checkbox-personalized">
            {!disabled ? (
                <div>
                    <input
                        type={mode}
                        checked={checked}
                        disabled={disabled}
                        readOnly={true}
                    />
                    <label htmlFor={`checkbox`}>
                        <div className="check"/>
                    </label>
                </div>
            ) : (
                <div/>
            )}
        </div>
    );
};